import {buildURL, formatURL} from "../../../utils";
import {ROOM_TYPE_PERSONAL} from "../../../constants/rooms";

export const ACCESS_ANONYMOUS = -1;
export const ACCESS_FREE = 0;
const ACCESS_XL = 1;
export const ACCESS_XXL = 2;
const ACCESS_GM = 3;
const ACCESS_TGM = 4;
const ACCESS_ADMIN = 5;
export const ACCESS_OWNER = 6;

export class BobTVUser {
    /**
     * @param {HitagiChatUser|object} user
     */
    constructor(user) {
        let obj = Object.assign(this, user);

        if(obj.private_data) {
            for(let prop in obj.private_data) {
                obj[prop] = obj.private_data[prop];
            }
            delete obj.private_data;
        }

        return obj;
    }

    getProfileURL() {
        return formatURL('/profil/{nick}', {nick: this.nick});
    }

    getGiveVirtualGiftURL() {
        return buildURL('/cadeaux-virtuels', {r: this.nick});
    }

    getGiveXXLURL() {
        return buildURL('/bobtv-xxl', {r: this.uid});
    }

    getExcludeURL(room) {
        let params = {nick: this.nick};

        if (room.type && room.type === ROOM_TYPE_PERSONAL) {
            params.roomid = room.id;
        }
        if (room.server_id) {
            params.server_id = room.server_id;
        }

        return buildURL('/exclude/confirm.php', params);
    }

    getBanURL() {
        return buildURL('/block/confirm.php', {nick: this.nick});
    }

    isAnonymous() {
        return isAnonymous(this);
    };

    isActivated() {
        return isActivated(this);
    };

    isXXL() {
        return isXXL(this);
    }

    isAdmin() {
        return isAdmin(this);
    }

    isOwner() {
        return isOwner(this);
    }

    isCertified() {
        return isCertified(this);
    }

    isCertificationDisabled() {
        return isCertificationDisabled(this);
    }

    /**
     * @param {HitagiChatUser|BobTVUser} user
     * @return {boolean}
     */
    isUserBlocked(user) {
        if(!user || !user.uid) return false;

        for (var index in this.blocklist) {
            if (this.blocklist[index] === user.uid) {
                return true;
            }
        }

        return false;
    }

    /**
     * @param {HitagiChatUser|BobTVUser|{uid}} user
     * @return {BlocklistEntry|boolean}
     */
    isBeingBlocked(user) {
        if(!user || !user.uid) return false;

        if (this.hasOwnProperty('blocked_by')) {

            for (let index in this.blocked_by) {
                if (this.blocked_by[index].uid === user.uid) return this.blocked_by[index];
            }

            return false;
        }

        let _user = user instanceof BobTVUser ? user : new BobTVUser(user);
        return _user.isUserBlocked(this);
    }

    isUserFollowed(user) {
        for (var index in this.followees) {
            if (this.followees[index] === user.uid) {
                return true;
            }
        }

        return false;
    }
}

/**
 * @param {HitagiChatUser|BobTVUser} user
 */
function isAnonymous(user) {
    return ACCESS_ANONYMOUS === user.member_type || user.uid < 0;
}

BobTVUser.isAnonymous = isAnonymous;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isFree(user) {
    return (ACCESS_FREE === user.member_type);
}

BobTVUser.isFree = isFree;

/**
 * @param {HitagiChatUser|BobTVUser} user
 */
function isXXL(user) {
    return (ACCESS_XXL <= user.member_type);
}

BobTVUser.isXXL = isXXL;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isAdmin(user) {
    return (ACCESS_ADMIN <= user.member_type);
}

BobTVUser.isAdmin = isAdmin;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isOwner(user) {
    return (ACCESS_OWNER === user.member_type);
}

BobTVUser.isOwner = isOwner;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isCertified(user) {
    return user.certified;
}

BobTVUser.isCertified = isCertified;

/**
 * @param {HitagiChatUser|BobTVUser} user
 * @return {boolean}
 */
function isCertificationDisabled(user) {
    return user.certification_disabled;
}

BobTVUser.isCertificationDisabled = isCertificationDisabled;

/**
 * @param {BobTVUser} currentUser
 * @param {HitagiChatUser|BobTVUser} userData
 * @return {string}
 */
export function getUserCSSClass(currentUser, userData) {
    let cssClasses = [];

    let gender = parseInt(userData.gender);

    if (gender == 1) {
        cssClasses.push('male');
    }

    if (gender == 2) {
        cssClasses.push('female');
    }

    if (gender == 3) {
        cssClasses.push('couple');
    }

    if (gender == 4) {
        cssClasses.push('trans');
    }

    if (BobTVUser.isAnonymous(userData)) {
        if (currentUser.isOwner()) {
            cssClasses.push('anonymous-alt');
        } else {
            cssClasses.push('anonymous');
        }
    }

    if (!BobTVUser.isCertified(userData)) {
        cssClasses.push('uncertified');
    }

    let giftRank = parseInt(userData.gift_rank);

    if (giftRank) {
        cssClasses.push('rank-' + giftRank);
    }

    if (currentUser.isUserBlocked(userData)) {
        cssClasses.push('blocked');
    }

    return cssClasses.join(' ');
}


export function findUser(state, user) {
    let connectedUser = state.users.get({uid: user.uid})
    if (connectedUser && connectedUser.online) {
        return connectedUser;
    }
    return user;
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/BobTVUser/index.js